import * as _ from 'lodash';
import { BaseObject } from './BaseObject';

export class MissionType extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);
        }
    }
}
